import PagesWrapper from "../mainpage/PagesWrapper";
import { Section } from "../../../types";
import styles from "./Datenschutz.module.css";

const Datenschutz = ({ bgData }: { bgData: Section[] }) => {
  return (
    <PagesWrapper data={bgData} hasTop={false}>
      <div style={{ wordWrap: "break-word" }}>
        <div className={styles.header}>DATENSCHUTZERKLÄRUNG</div>
        <p>
          Allgemeiner Hinweis und Pflichtinformationen
          <br />
          Benennung der verantwortlichen Stelle
          <br />
          Die verantwortliche Stelle f&uuml;r die Datenverarbeitung auf dieser
          Website ist:
          <br />
          <br />
          <br />
          Uwe Scheutzel
          <br />
          Julius-Vosseler-Str. 97a
          <br />
          22527 Hamburg
          <br />
          <br />
          Die verantwortliche Stelle entscheidet allein oder gemeinsam mit
          anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von
          personenbezogenen Daten (z.B. Namen, Kontaktdaten o. &Auml;.).
          <br />
          <br />
          Widerruf Ihrer Einwilligung zur Datenverarbeitung
          <br />
          Nur mit Ihrer ausdr&uuml;cklichen Einwilligung sind einige
          Vorg&auml;nge der Datenverarbeitung m&ouml;glich. Ein Widerruf Ihrer
          bereits erteilten Einwilligung ist jederzeit m&ouml;glich. F&uuml;r
          den Widerruf gen&uuml;gt eine formlose Mitteilung per E-Mail. Die
          Rechtm&auml;&szlig;igkeit der bis zum Widerruf erfolgten
          Datenverarbeitung bleibt vom Widerruf unber&uuml;hrt.
          <br />
          <br />
          Recht auf Beschwerde bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde
          <br />
          Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen
          Versto&szlig;es ein Beschwerderecht bei der zust&auml;ndigen
          Aufsichtsbeh&ouml;rde zu. Zust&auml;ndige Aufsichtsbeh&ouml;rde
          bez&uuml;glich datenschutzrechtlicher Fragen ist der
          Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz
          unseres Unternehmens befindet. Der folgende Link stellt eine Liste der
          Datenschutzbeauftragten sowie deren Kontaktdaten bereit:
          https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
          <br />
          <br />
          Recht auf Daten&uuml;bertragbarkeit
          <br />
          Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer
          Einwilligung oder in Erf&uuml;llung eines Vertrags automatisiert
          verarbeiten, an sich oder an Dritte aush&auml;ndigen zu lassen. Die
          Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie
          die direkte &Uuml;bertragung der Daten an einen anderen
          Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
          machbar ist.
          <br />
          <br />
          Recht auf Auskunft, Berichtigung, Sperrung, L&ouml;schung
          <br />
          Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen
          das Recht auf unentgeltliche Auskunft &uuml;ber Ihre gespeicherten
          personenbezogenen Daten, Herkunft der Daten, deren Empf&auml;nger und
          den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung,
          Sperrung oder L&ouml;schung dieser Daten. Diesbez&uuml;glich und auch
          zu weiteren Fragen zum Thema personenbezogene Daten k&ouml;nnen Sie
          sich jederzeit &uuml;ber die im Impressum aufgef&uuml;hrten
          Kontaktm&ouml;glichkeiten an uns wenden.
          <br />
          <br />
          SSL- bzw. TLS-Verschl&uuml;sselung
          <br />
          Aus Sicherheitsgr&uuml;nden und zum Schutz der &Uuml;bertragung
          vertraulicher Inhalte, die Sie an uns als Seitenbetreiber senden,
          nutzt unsere Website eine SSL-bzw. TLS-Verschl&uuml;sselung. Damit
          sind Daten, die Sie &uuml;ber diese Website &uuml;bermitteln, f&uuml;r
          Dritte nicht mitlesbar. Sie erkennen eine verschl&uuml;sselte
          Verbindung an der &#8222;https://&ldquo; Adresszeile Ihres Browsers
          und am Schloss-Symbol in der Browserzeile.
          <br />
          <br />
          Server-Log-Dateien
          <br />
          In Server-Log-Dateien erhebt und speichert der Provider der Website
          automatisch Informationen, die Ihr Browser automatisch an uns
          &uuml;bermittelt. Dies sind:
          <br />
          <br />
          Besuchte Seite auf unserer Domain
          <br />
          <br />
          Datum und Uhrzeit der Serveranfrage
          <br />
          <br />
          Browsertyp und Browserversion
          <br />
          <br />
          Verwendetes Betriebssystem
          <br />
          <br />
          Referrer URL
          <br />
          <br />
          Hostname des zugreifenden Rechners
          <br />
          <br />
          IP-Adresse
          <br />
          <br />
          Es findet keine Zusammenf&uuml;hrung dieser Daten mit anderen
          Datenquellen statt. Grundlage der Datenverarbeitung bildet Art. 6 Abs.
          1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf&uuml;llung
          eines Vertrags oder vorvertraglicher Ma&szlig;nahmen gestattet.
          <br />
          <br />
          Kontaktformular
          <br />
          Per Kontaktformular &uuml;bermittelte Daten werden
          einschlie&szlig;lich Ihrer Kontaktdaten gespeichert, um Ihre Anfrage
          bearbeiten zu k&ouml;nnen oder um f&uuml;r Anschlussfragen
          bereitzustehen. Eine Weitergabe dieser Daten findet ohne Ihre
          Einwilligung nicht statt.
          <br />
          <br />
          Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt
          ausschlie&szlig;lich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1
          lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist
          jederzeit m&ouml;glich. F&uuml;r den Widerruf gen&uuml;gt eine
          formlose Mitteilung per E-Mail. Die Rechtm&auml;&szlig;igkeit der bis
          zum Widerruf erfolgten Datenverarbeitungsvorg&auml;nge bleibt vom
          Widerruf unber&uuml;hrt.
          <br />
          <br />
          &Uuml;ber das Kontaktformular &uuml;bermittelte Daten verbleiben bei
          uns, bis Sie uns zur L&ouml;schung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder keine Notwendigkeit der Datenspeicherung
          mehr besteht. Zwingende gesetzliche Bestimmungen - insbesondere
          Aufbewahrungsfristen - bleiben unber&uuml;hrt.
          <br />
          <br />
          Google Maps
          <br />
          Art und Umfang der Verarbeitung
          <br />
          Wir verwenden zur Erstellung von Anfahrtsbeschreibungen den
          Kartendienst Google Maps. Google Maps ist ein Dienst der Google
          Ireland Limited, welcher auf unserer Website eine Karte darstellt.
          Wenn Sie auf diese Inhalte unserer Website zugreifen, stellen Sie eine
          Verbindung zu Servern der Google Ireland Limited, Gordon House, Barrow
          Street, Dublin 4, Irland her, wobei Ihre IP-Adresse und ggf.
          Browserdaten wie Ihr User-Agent &uuml;bermittelt werden. Diese Daten
          werden ausschlie&szlig;lich zu den oben genannten Zwecken und zur
          Aufrechterhaltung der Sicherheit und Funktionalit&auml;t von Google
          Maps verarbeitet.
          <br />
          <br />
          Zweck und Rechtsgrundlage
          <br />
          Der Einsatz von Google Maps erfolgt auf Grundlage Ihrer Einwilligung
          gem&auml;&szlig; Art. 6 Abs. 1 lit. a. DSGVO und &sect; 25 Abs. 1
          TTDSG.
          <br />
          <br />
          Wir beabsichtigen personenbezogenen Daten an Drittl&auml;nder
          au&szlig;erhalb des Europ&auml;ischen Wirtschaftsraums, insbesondere
          die USA, zu &uuml;bermitteln. In F&auml;llen, in denen kein
          Angemessenheitsbeschluss der Europ&auml;ischen Kommission existiert
          (z.B. in den USA) haben wir mit den Empf&auml;ngern der Daten
          anderweitige geeignete Garantien im Sinne der Art. 44 ff. DSGVO
          vereinbart. Dies sind &ndash; sofern nicht anders angegeben &ndash;
          Standardvertragsklauseln der EU-Kommission gem&auml;&szlig;
          Durchf&uuml;hrungsbeschluss (EU) 2021/914 vom 4. Juni 2021. Eine Kopie
          dieser Standardvertragsklauseln k&ouml;nnen Sie unter
          https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32021D0914&amp;from=DE
          einsehen.
          <br />
          <br />
          Zudem holen wir vor einem solchen Drittlandtransfer Ihre Einwilligung
          nach Art. 49 Abs. 1 Satz 1 lit. a. DSGVO ein, die Sie &uuml;ber die
          Einwilligung im Consent Manager (oder sonstigen Formularen,
          Registrierungen etc.) erteilen. Wir weisen Sie darauf hin, dass bei
          Drittland&uuml;bermittlungen im Detail unbekannte Risiken (z.B. die
          Datenverarbeitung durch Sicherheitsbeh&ouml;rden des Drittlandes,
          deren genauer Umfang und deren Folgen f&uuml;r Sie wir nicht kennen,
          auf die wir keinen Einfluss haben und von denen Sie unter
          Umst&auml;nden keine Kenntnis erlangen) bestehen k&ouml;nnen.
          <br />
          <br />
          Speicherdauer
          <br />
          Die konkrete Speicherdauer der verarbeiteten Daten ist nicht durch uns
          beeinflussbar, sondern wird von Google Ireland Limited bestimmt.
          Weitere Hinweise finden Sie in der Datenschutzerkl&auml;rung f&uuml;r
          Google Maps: https://policies.google.com/privacy.
          <br />
          <br />
          Quelle: Datenschutz-Konfigurator von Mein-Datenschutzbeauftragter.de
        </p>
      </div>
    </PagesWrapper>
  );
};

export default Datenschutz;
